import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// components
import { ButtonOutlineLarge, ButtonOutlineSmall, ButtonPrimaryLarge, ButtonPrimarySmall, H4, BodyMedium } from '@styled';

// functionality
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import { useScreenMinMd } from '@hooks/useResponsive';

export const modalStyles = {
    body: {
        paddingBottom: '20px',
        paddingTop: '10px',
    },
    content: {
        maxWidth: 'auto',
        minWidth: 'auto',
        width: '594px',
    },
    overlay: {},
};

const BodyContainerStyled = styled.div`
    padding-left: 43px;
    padding-right: 43px;
`;

const ButtonContainerStyled = styled.div`
    border-top: 1px solid ${colors.lightGray};
    bottom: 20px;
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    position: absolute;
    width: 100%;

    @media ${mediaQueries.md} {
        position: static;
    }
`;

const EventDetailsLinkStyled = styled.a`
    display: block;
    text-align: right;
    margin-bottom: 20px;
    margin-right: 24px;
    text-decoration: none;
    color: #246EFF;

    &:hover {
        color: #0051f0;
    }

    &:after {
        content: '';
        display: inline-block;
        background: url(/assets/images/view-all-arrow.svg) no-repeat;
        background-size: 18.375px 14px;
        width: 18.375px;
        height: 16px;
        margin-left: 10px;
        vertical-align: middle;
    }
`;

const MessageContainerStyled = styled.div`
    margin-top: 2rem;
    margin-bottom: 2rem;
`;

const CartCrossSellModalBase = ({
    heading,
    message,
    eventCode,
    onRegisterClick,
    onCancelClick,
}) => {
    // ------------------------------
    // Hooks
    // ------------------------------

    const isScreenMinMd = useScreenMinMd();

    // ------------------------------
    // Render
    // ------------------------------

    return (
        <div>
            <BodyContainerStyled>
                <H4>{heading}</H4>

                <MessageContainerStyled>
                    <BodyMedium>{message}</BodyMedium>
                </MessageContainerStyled>
            </BodyContainerStyled>

            <EventDetailsLinkStyled href={`/${eventCode}`}>
                See Event Details
            </EventDetailsLinkStyled>

            {isScreenMinMd && (
                <ButtonContainerStyled>
                    <ButtonOutlineLarge onClick={onCancelClick}>Cancel</ButtonOutlineLarge>
                    <ButtonPrimaryLarge className="ml-1rem" onClick={onRegisterClick}>
                        SAVE TODAY
                    </ButtonPrimaryLarge>
                </ButtonContainerStyled>
            )}

            {!isScreenMinMd && (
                <ButtonContainerStyled>
                    <ButtonOutlineSmall onClick={onCancelClick}>Cancel</ButtonOutlineSmall>
                    <ButtonPrimarySmall className="ml-1rem" onClick={onRegisterClick}>
                        SAVE TODAY
                    </ButtonPrimarySmall>
                </ButtonContainerStyled>
            )}
        </div>
    );
};

CartCrossSellModalBase.propTypes = {
    heading: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    eventCode: PropTypes.string.isRequired,
    onRegisterClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
};

export default CartCrossSellModalBase;